
export default {
    name: 'print-bon-medical',
    components: {},
    props: {
        info_bon: {
            type: Object,
            default: () => {}
        },
        is_bon_consultation: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            is_printing: false
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        printBonMedical() {
            this.is_printing = true
            setTimeout(() => {
                window.print()
                this.is_printing = false
            }, 1000);
        }
    }
}